import * as Yup from "yup";

export enum IMeetingStatus {
    None = "NONE",
    Scheduled = "SCHEDULED",
    Started = "STARTED",
    End = "END"
}

export enum IMeetingUserStatus {
    Offline = "OFFLINE",
    Online = "ONLINE"
}

export enum ISlideType {
    none = 'NONE',
    link = "LINK",
    html = "HTML"
}

export const MEETING_AUDIO_SCHEMA = Yup.object({
    audioUid: Yup.number().default(()=>{
        return Math.floor(100000000 + Math.random() * 900000000)
    }).defined(),
    channelName: Yup.string().default('').defined(),
    isMute: Yup.boolean().default(false).defined(),
    optedIn: Yup.boolean().default(false).defined()
}).defined()

export type IMeetingAudio = Yup.InferType<typeof MEETING_AUDIO_SCHEMA>;


export const MEETING_PARTICIPANT_SCHEMA = Yup.object().shape({
    displayName: Yup.string().defined().default(''),
    id: Yup.string().defined().default(''),
    imageUrl: Yup.string().defined().default(''),
    status: Yup.string().oneOf(Object.values(IMeetingUserStatus)).default(IMeetingUserStatus.Offline).defined(),
    audio: MEETING_AUDIO_SCHEMA
}).defined();

export type IMeetingParticipant = Yup.InferType<typeof MEETING_PARTICIPANT_SCHEMA>;

export const MEETING_PRESENTER_SCHEMA = Yup.object().shape({
    displayName: Yup.string().defined().default(''),
    id: Yup.string().defined().default(''),
    imageUrl: Yup.string().defined().default(''),
    status: Yup.string().oneOf(Object.values(IMeetingUserStatus)).default(IMeetingUserStatus.Offline).defined(),
    audio: MEETING_AUDIO_SCHEMA
}).defined();

export type IMeetingPresenter = Yup.InferType<typeof MEETING_PRESENTER_SCHEMA>;


export const WHO_SCHEMA = Yup.object({
    createdOn: Yup.date().default(() => new Date()).transform(function (value, originalvalue) {
      //return this.isType(value) ? new Date(originalvalue._seconds): value;//TODO
      return new Date()
    }),
    owner: Yup.object({
      uid: Yup.string().default(() => {
        return 'anonymous'
      }),
      displayName: Yup.string().defined().default(() => {
        return 'anonymous'
      }),
      imageUrl: Yup.string().default(() => {
        return '';
      })
    }).defined()
  }).defined();

/*export interface IMeetingSlide {
    content: string,
    type: ISlideType
}

export interface IMeetingPresentation {
    currentSlide : number,
    docId : string,
    docUrl : string,
    fileName : string,
    name: string,
    lastSlideChangeTs : any,
    noOfSlides : number,
    slides : Array<IMeetingSlide>
}*/

export const MEETING_PRESENTATION_SCHEMA = Yup.object({
    currentSlide: Yup.number().default(0).defined(),
    docId: Yup.string().default('').defined(),
    fileName: Yup.string().default('').defined(),
    docUrl: Yup.string().default('').defined(),
    name: Yup.string().default('').defined(),
    lastSlideChangeTs: Yup.number().default(0).defined(),
    noOfSlides: Yup.number().default(0).defined(),
    slides: Yup.array().of(Yup.object({
                content: Yup.string().default('').defined(),
                type: Yup.string().oneOf(Object.values(ISlideType)).default(ISlideType.link)
        })).defined().default([])
}).defined()

export type IMeetingPresentation = Yup.InferType<typeof MEETING_PRESENTATION_SCHEMA>;

export const MEETING_SCHEMA = Yup.object({
    uid: Yup.string(),
    title: Yup.string().required('Enter a Title').default('').defined(),
    status: Yup.string().oneOf(Object.values(IMeetingStatus)).default(IMeetingStatus.Scheduled).defined(),
    channelName: Yup.string().default(''),
    startTime: Yup.number().required('Enter a Start Time').defined().default(()=> new Date().getTime()),
    endTime: Yup.number().required('Enter a end Time').defined().default(()=> new Date().getTime() + 30*60*1000),
    actualStartTime: Yup.number().defined().default(0),
    actualEndTime: Yup.number().defined().default(0),
    shareUrl: Yup.string().defined().default(''),
    presenter: MEETING_PRESENTER_SCHEMA,
    participants: Yup.array().of(MEETING_PARTICIPANT_SCHEMA),
    presentation: MEETING_PRESENTATION_SCHEMA,
    who: WHO_SCHEMA
}).defined();

 type IMeeting = Yup.InferType<typeof MEETING_SCHEMA>;


 export const newMeetingInstance = ():IMeeting => {
    const obj =  MEETING_SCHEMA.cast();
    return Object.assign({},obj);
  }

  export const newParticipantInstance = (participant:Partial<IMeetingParticipant>):IMeetingParticipant => {
      return Object.assign(MEETING_PARTICIPANT_SCHEMA.cast())
  }
  
  export const newPresenterInstance = (presenter:Partial<IMeetingPresenter>):IMeetingPresenter => {
    return Object.assign(MEETING_PRESENTER_SCHEMA.cast(), presenter)
  }

  export const newPresentationInstance = (presentation:Partial<IMeetingPresentation>):IMeetingPresentation => {
    return Object.assign(MEETING_PRESENTATION_SCHEMA.cast(), presentation)
}

  export const isMeetingValid = async (doc:IMeeting) => {
    const valid:boolean =  await MEETING_SCHEMA.isValid(doc);
    return valid;
  }
  
  export const validateMeeting = async (doc:IMeeting) => {
    let errors:any = {};
    try{
      const err:any = await MEETING_SCHEMA.validate(doc, {abortEarly: false});
    }catch(err){
      errors= err.inner.reduce((obj:any, item:any) => {
        obj[item.path] = item.message;
        return obj;
      }, {});
    }
    return errors;
  }
  
  export const convertToMeeting = (doc:any):IMeeting => {
    return MEETING_SCHEMA.cast(doc);
  }



 export default IMeeting;

/*export default interface IMeeting {
    uid: string,
    startTime : any,
    status : IMeetingStatus,
    title : string,
    useAudio : boolean
    actualEndTime : any,
    actualStartTime : any,
    channelName : string,
    endTime : any,
    shareUrl : string,
    presenter : IMeetingPresenter,
    participants : Array<IMeetingParticipant>,
    presentation : IMeetingPresentation
  }
  */
  